// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketTwoToneSvg from "@ant-design/icons-svg/es/asn/RocketTwoTone";
import AntdIcon from '../components/AntdIcon';

var RocketTwoTone = function RocketTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketTwoToneSvg
  }));
};

RocketTwoTone.displayName = 'RocketTwoTone';
export default React.forwardRef(RocketTwoTone);